import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37708dea"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "fas fa-circle-notch fa-spin"
}

import { computed, ref, onMounted, inject } from 'vue';
import { useStore } from 'vuex';
import { v4 as uuidv4 } from 'uuid';

const delay = 200;

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressButton',
  props: {
  disabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['click', 'dblclick'],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore();
const id = ref(uuidv4());
const timer = ref<number>(0);
const prevent = ref(false);
const actProperty: any = inject('actProperty');

const emit = __emit

// Access state using composition API
const appState = computed(() => store.state.app);

// Convert mutations to store.commit calls
const addRequest = (payload: { id: string; blocking: boolean }) => {
  store.commit('app/addRequest', payload);
};

onMounted(() => {
  id.value = uuidv4();
});

const inProgress = computed(() => {
  return appState.value.requests.find((r: any) => r.id === id.value);
});

const onClick = () => {
  if (inProgress.value) {
    return;
  }

  (timer.value as any) = setTimeout(() => {
    if (!prevent.value) {
      emit('click', id.value);
    }
    prevent.value = false;
  }, delay);
};

const onDblclick = () => {
  if (inProgress.value) {
    return;
  }

  clearTimeout(timer.value);
  prevent.value = true;
  emit('dblclick', id.value);

  addRequest({
    id: id.value,
    blocking: false,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: onClick,
    onDblclick: onDblclick,
    disabled: __props.disabled
  }, [
    (inProgress.value)
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 40, _hoisted_1))
}
}

})